module.exports = __webpack_public_path__ + "static/media/nba2020.f018de02.jpg";